// extracted by mini-css-extract-plugin
export var closeButton = "_13-3";
export var header = "_13-0";
export var link = "_13-1";
export var retryButton = "_13-2";